<template>
    <layout-login>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card>
                    <v-card-text class="text-center pa-10">
                        <p class="display-2">404</p>
                        <p class="headline">
                            {{ $t('not_found.not_found') }}
                        </p>
                        <v-btn color="primary" :to="{name: 'home'}">
                            {{ $t('not_found.go_to_home') }}
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </layout-login>
</template>

<script>
    import LayoutLogin from "@/layouts/LayoutLogin";

    export default {
        name: 'NotFound',
        components: {LayoutLogin}
    }
</script>
